var React = require('react');

function Play (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 19.9997V1.99968C0 1.20852 0.875246 0.730675 1.54076 1.1585L15.5408 10.1585C16.1531 10.5521 16.1531 11.4472 15.5408 11.8409L1.54076 20.8409C0.875246 21.2687 0 20.7908 0 19.9997Z","fill":"black"}));
}

Play.defaultProps = {"width":"16","height":"22","viewBox":"0 0 16 22"};

module.exports = Play;

Play.default = Play;
